import { SizeType } from 'antd/es/config-provider/SizeContext';
import * as React from 'react';
import {
  Datatype,
  PlainArrayFieldDatatype,
  isObjectsArrayField,
} from '../../../datatype/Datatype';
import { IReference } from '../../../references/IReference';
import { AssignableExpressionInput } from '../../assignable/input/AssignableExpressionInput';
import { IConditionOperatorArgument } from '../../operators/IConditionOperator';
import { SubconditionsGroupInput } from '../../subconditions-group/input/SubconditionsGroupInput';
import { IConditionExpression } from '../IConditionExpression';

export interface IConditionArgumentInputProps {
  condition: IConditionExpression;
  arg: IConditionOperatorArgument;
  references: IReference[];
  name: string;
  size?: SizeType;
}

export function ConditionArgumentInput(props: IConditionArgumentInputProps) {
  const { arg, condition, references, name, size } = props;
  // La reference può essere null se non è stata ancora selezionata o se è stata resettata
  const conditionReference = condition.reference as
    | typeof condition.reference
    | null;

  if (!conditionReference) return null;

  // Se è un array di oggetti, mostriamo un input per la lista di condizioni.
  // Praticamente mostriamo dei check sui singoli campi dell'oggetto
  if (
    arg.type === 'arrayMatching' &&
    isObjectsArrayField(conditionReference.field)
  ) {
    return (
      <SubconditionsGroupInput
        size={size ?? 'middle'}
        name={`${name}`}
        conditionReference={conditionReference}
      />
    );
  }

  return (
    <AssignableExpressionInput
      size={size ?? 'middle'}
      references={references}
      name={`${name}`}
      field={getFieldForArg(arg, condition)}
    />
  );
}

function getFieldForArg(
  arg: IConditionOperatorArgument,
  condition: IConditionExpression,
) {
  if (arg.type === 'staticValue') {
    return arg.field;
  }

  // Nel caso di un array, il tipo è sempre array e gli items sono
  // del tipo del campo
  if (
    arg.type === 'referenceValue' &&
    arg.isArray &&
    condition.reference.field.type !== Datatype.Array
  ) {
    return {
      type: Datatype.Array,
      itemsType: condition.reference.field.type,
      options: condition.reference.field.options,
    } as PlainArrayFieldDatatype;
  }

  return condition.reference.field;
}
